import { useEffect, useState } from "react";
import axios from "axios";
import { Inbox } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Contact form messages from /contact (newest first).
export default function ContactMessages({ token }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    axios.get(`${API}/analytics/contact-messages`, { headers: { "X-Analytics-Token": token } }).then(({ data }) => setRows(data.messages)).catch(() => setRows([]));
  }, [token]);
  return (
    <section data-testid="contact-messages" className="bg-[#0F1523] border border-[#D4AF37]/20 rounded-2xl p-5">
      <h2 className="flex items-center gap-2 text-lg mb-3"><Inbox size={17} className="gold-text" /> Contact messages</h2>
      {!rows ? <p className="text-sm text-[#A7B0C0]">Loading…</p> : !rows.length ? <p className="text-sm text-[#A7B0C0]" data-testid="contact-messages-empty">No messages yet.</p> : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {rows.map((m) => (
            <div key={m.id} data-testid={`contact-message-${m.id.slice(0, 6)}`} className="bg-[#0B0F19] rounded-xl p-3">
              <p className="text-sm text-starlight">{m.subject || "(no subject)"} · <a className="gold-text" href={`mailto:${m.email}?subject=${encodeURIComponent(`Re: ${m.subject || "your message"}`)}`}>{m.name} &lt;{m.email}&gt;</a></p>
              <p className="text-[11px] text-[#A7B0C0]">{new Date(m.created_at).toLocaleString()} · {m.emailed ? "forwarded to your inbox" : "not emailed"}</p>
              <p className="text-sm text-[#D6D0C5] whitespace-pre-wrap mt-1">{m.message}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
